.sentinel {
  height: 0;
}

.bar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 8px;
  min-height: calc(56px + var(--safe-top));
  padding: var(--safe-top) 8px 0;
  /* Solid: a see-through bar reads badly on Android, where blur isn't reliable. */
  background: var(--bg);
  transition:
    background-color var(--dur-fade) var(--ease),
    box-shadow var(--dur-fade) var(--ease);
}

.pane {
  min-height: 56px;
  padding-top: 0;
}

.scrolled {
  background: var(--bg);
  box-shadow: inset 0 -1px 0 var(--line);
}

/* Over a picture (the flight's sky) it starts clear and turns solid once scrolled. */
.overlay:not(.scrolled) {
  background: transparent;
  color: var(--sky-ink, var(--text));
}

.overlay {
  position: fixed;
  left: 0;
  right: 0;
}

.overlay.pane {
  position: sticky;
}

.side {
  display: flex;
  align-items: center;
  gap: 2px;
  min-width: 0;
}

.end {
  justify-content: flex-end;
}

.title {
  max-width: 60vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  opacity: 0;
  transform: translateY(4px);
  transition:
    opacity var(--dur-fade) var(--ease),
    transform var(--dur-fade) var(--ease);
}

.scrolled .title {
  opacity: 1;
  transform: none;
}

/* Desktop: float over the hero inside the main column, not the whole window. */
.overlay.inMain {
  position: sticky;
  margin-bottom: -56px;
}

/* Over a picture the sky can be dark or bright: buttons get their own dark backing. */
.overlay:not(.scrolled) button {
  background: rgb(0 0 0 / 0.38);
  color: #fff;
}
